import { useEffect, useState } from "react";
import { X } from "lucide-react";
import PageHero from "../components/PageHero";
import { fetchGallery } from "../lib/api";

export default function Galleria() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchGallery().then(setItems).catch(() => {});
  }, []);

  return (
    <div data-testid="page-galleria">
      <PageHero
        eyebrow="Galleria"
        title="Istantanee"
        italic="dalla scuola."
        subtitle="Saggi, concerti, masterclass e momenti di vita scolastica. La musica in immagini."
      />

      <section className="py-20 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5" data-testid="gallery-grid">
          {items.map((img, i) => (
            <button
              key={img.id}
              onClick={() => setSelected(img)}
              data-testid={`gallery-item-${img.id}`}
              className={`group relative overflow-hidden bg-[#A3133A]/5 ${i % 5 === 0 ? "md:row-span-2 aspect-square md:aspect-[3/4]" : "aspect-[4/3]"}`}
            >
              <img
                src={img.url}
                alt={img.titolo}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-[#A3133A]/0 group-hover:bg-[#A3133A]/70 transition-all flex items-end p-5">
                <span className="text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                  {img.titolo}
                </span>
              </div>
            </button>
          ))}
        </div>
      </section>

      {selected && (
        <div
          className="fixed inset-0 bg-black/90 z-[60] flex items-center justify-center p-4"
          onClick={() => setSelected(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setSelected(null)}
            className="absolute top-6 right-6 text-white p-2"
            data-testid="lightbox-close"
          >
            <X size={24} />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={selected.url} alt={selected.titolo} className="w-full h-auto max-h-[80vh] object-contain" />
            <div className="text-center text-white/80 font-serif-display text-xl mt-4">{selected.titolo}</div>
          </div>
        </div>
      )}
    </div>
  );
}
